module.exports = __webpack_public_path__ + "804dca51.svg";